const Theme = {
  body_background_color: '#00ADB8',
  title_font: 'Poppins',
  text_font: 'Poppins',
  
  logo_image_url: 'monveto.png',
  logo_height: 90,
  token_url: 'monveto.png',
  token_hidden: true,
  number_hidden: true,

  card_header_margin_top: 0,
  header_no_border: true,
  button_border_width: 3,
  button_color: '#00ADB8',
  button_half_border_color: '#00ADB8',
  button_radius: 100,
  footer_background_color: '#00ADB8',
  title_margin: '10px',
}

export default Theme
// https://app.clickup.com/t/86dtpzcn4